<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">

            <!-- Título da página -->
            <div class="page-title-area">
                <div class="container-fluid">
                    <div class="row align-items-center">
                        <div class="col-auto">
                            <h2 class="page-title">Dashboard GGMF</h2>
                            <p class="page-subtitle">Bem-vindo ao painel de controlo</p>
                        </div>
                        <div class="col-auto ms-auto">
                            <button class="refresh-btn" :class="{ spinning: loading }" @click="loadStats" title="Atualizar">
                                <i class="ri-refresh-line"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Erro de ligação -->
            <div v-if="error" class="container-fluid mb-3">
                <div class="dashboard-error">
                    <i class="ri-wifi-off-line"></i>
                    <span>{{ error }}</span>
                    <button @click="loadStats">Tentar novamente</button>
                </div>
            </div>

            <!-- Cards de estatísticas -->
            <StatsCards :counts="stats.counts" :loading="loading" />

            <!-- Gráfico + Eventos Próximos -->
            <div class="container-fluid">
                <div class="row">
                    <div class="col-xl-8">
                        <DonationsChart :donations-chart="stats.donationsChart" :loading="loading" />
                    </div>
                    <div class="col-xl-4">
                        <UpcomingEvents :events="stats.upcomingEvents" :loading="loading" />
                    </div>
                </div>
            </div>

            <!-- Últimas Notícias + Projetos Recentes -->
            <div class="container-fluid">
                <div class="row">
                    <div class="col-xl-6">
                        <LatestNews :news="stats.latestNews" :loading="loading" />
                    </div>
                    <div class="col-xl-6">
                        <RecentProjects :projects="stats.recentProjects" :loading="loading" />
                    </div>
                </div>
            </div>

            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader';
import FooterArea from '../Layouts/FooterArea';
import StatsCards from '../Dashboards/GgmfDashboard/StatsCards';
import DonationsChart from '../Dashboards/GgmfDashboard/DonationsChart';
import UpcomingEvents from '../Dashboards/GgmfDashboard/UpcomingEvents';
import LatestNews from '../Dashboards/GgmfDashboard/LatestNews';
import RecentProjects from '../Dashboards/GgmfDashboard/RecentProjects';
import dashboardService from '../../services/dashboardService';

export default {
    name: 'WebsiteAnalyticsPage',
    components: {
        MainHeader,
        FooterArea,
        StatsCards,
        DonationsChart,
        UpcomingEvents,
        LatestNews,
        RecentProjects,
    },

    data() {
        return {
            loading: true,
            error: '',
            stats: {
                counts: { news: 0, events: 0, projects: 0, donations: 0 },
                donationsChart: [],
                upcomingEvents: [],
                latestNews: [],
                recentProjects: [],
            },
        };
    },

    mounted() {
        document.body.classList.add('body-bg-f8faff');
        this.loadStats();
    },

    methods: {
        async loadStats() {
            this.loading = true;
            this.error = '';
            try {
                this.stats = await dashboardService.getStats();
            } catch (err) {
                console.error('Erro ao carregar dashboard:', err);
                this.error = 'Não foi possível carregar as estatísticas. Verifique se o servidor está activo.';
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss">
@import '../Dashboards/GgmfDashboard/ggmf-card';

.page-title-area {
    padding: 24px 0 16px;
    .page-title {
        font-size: 22px;
        font-weight: 700;
        margin: 0 0 2px;
    }
    .page-subtitle {
        font-size: 13px;
        color: #9ca3af;
        margin: 0;
    }
}
.refresh-btn {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid #DFE9FF;
    background: #fff;
    color: #1765FD;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.2s;
    &:hover { background: #EBF1FF; }
    &.spinning i { animation: rotate 0.8s linear infinite; }
}
@keyframes rotate {
    to { transform: rotate(360deg); }
}
.dashboard-error {
    background: #FFF0F0;
    border: 1px solid #FFCDD2;
    border-radius: 12px;
    padding: 14px 20px;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    color: #C62828;
    i { font-size: 18px; }
    button {
        margin-left: auto;
        background: #C62828;
        color: #fff;
        border: none;
        border-radius: 8px;
        padding: 6px 14px;
        font-size: 12px;
        cursor: pointer;
        &:hover { background: #B71C1C; }
    }
}
</style>